<template>
    <div class="scale-100 h-screen overflow-hidden" @mousemove="doMouse">
        {{ page }}
        <link v-for="i in images" rel="preload" :href="`/storage/images/${i.file}-${size}.${extension}`" as="image" :key="i.id">
        <div class="w-screen flex flex-wrap h-screen m-0 p-0 ">
            <!-- <transition-group name="list"> -->
                <div :class="['panel ', getClass(index)]"  v-for="i, index in images" :key="i.id" @click="rotateImages(index)" >
                    <figure :class="['h-screen ']" :style="`background-image: url('/storage/images/${i.file}-${size}.${extension}')`"  >

                    </figure>
                    <!-- <img class="h-screen w-screen object-fit" :src="`/storage/images/${i.file}-${size}.${extension}`" /> -->
                    <div v-if="index==1" ref="cap" :class="['headz bg-slate-950/70 p-4 fixed bottom-2 left-16', !intervals[1]['mouse'] ? 'opacity-1': 'opacity-1']"><Link :href="'/bio'">{{ images[1].name}}<br><span class="text-xs">{{ images[1].medium }}</span></Link></div>
                </div>
            <!-- </transition-group> -->
        </div>

    </div>
</template>

<script>
import { mapWritableState } from 'pinia'
import { generalStore } from '@/stores/generalStore';
import { Link } from '@inertiajs/vue3'

export default {
   name: "ImageTest",
   props: ['page'],
   components: { Link },
   computed: {
        ...mapWritableState(generalStore, ['intervals', 'mousing'])
   },
   watch: {
        mousing(n) {
            // if(n) {
            //     animate(this.$refs['cap'], {
            //         // Property keyframes
            //         opacity: [
            //             { to: 1, ease: 'outExpo', duration: 600 },
            //         ],
            //         y: [
            //             {to: 0, duration: 500}
            //         ],
            //         // Property specific parameters
            //         ease: 'inOutCirc',
            //         });
            // }else{
            //     animate(this.$refs['cap'], {
            //         y: [
            //             {to: '10px', ease: 'outExpo', duration: 500}
            //         ],
            //         opacity: [
            //             {to: 0, duration: 1000}
            //         ]
            //     });
            // }
        }
   },
   data() {
       return {
            viewportSize: document.windowWidth,
            size: '1920x1080',
            extension: 'jpg',
            images: [
                // { id: 'cc1', name: 'Cool Chick', medium: 'Canvas', file: 'Cool-Chick'},
                { id: 'tskw', name: 'TSKW Scrolling', medium: 'Canvas/Oil', file: 'TSKW Scrolling'},
                { id: 'orig1', name: 'Origination I', medium: 'Air', file: 'Narratives Scrolling'},
                { id: 'whta', name: 'What Happened to Alice?', medium: 'Air', file: 'What Happend to Alice Scrolling'},
                { id: 'cobm', name: 'CoB Maelstrom', medium: 'Air', file: 'CoB Maelstrom Scrolling'},
                { id: 'bca', name: 'BCA', medium: 'Air', file: 'BCA Scrolling'},
                { id: 'Gard', name: 'Gardens', medium: 'Air', file: 'Gardens Scrolling'},
                // { id: 'orig2', name: 'Origination II', medium: 'Fire', file: 'Origination-II'},
            ]
       }
   },
   mounted() {
        this.adjustImages();
   },
   methods: {
        adjustImages() {
          if(this.images.length == 2) {
            this.images.push({ id: this.images[0].id+'1', name: 'Cool Chick', medium: 'Canvas', file: 'Cool-Chick'},);
            return;
          }
          if(this.images.length == 1) {
            return;
            // this.images.push({ id: this.images[0].id+'2', name: this.images[0].name, medium: this.images[0].medium, file: this.images[0].file});
          }

        },
        rotateImages(i) {
            if(this.images.length == 1) return;
            // if(this.images.length == 2) {
            //     if(i == 0) {
            //         return;
            //     }
            //     return this.images.push(this.images.shift());
            // }
            if(i == 1) return;
            if(i == 0) {
                this.unshiftImages();
                return;
            }
            this.pushImages();
        },
        pushImages() {
            this.images.push(this.images.shift());
        },
        unshiftImages() {
            this.images.unshift(this.images.pop());
        },
        doMouse() {
            // this.mousing=true;
            this.intervals[0]['mouse']=true
            this.intervals[1]['mouse']=true
        },
        checkKey(e) {
            // console.log(e)
        },
        getClass(index) {
            if(index > 3) {
                return 'hidden';
            }
            switch (this.images.length) {
                case 1:
                    // return 'w-full'
                default:

                    if(index == 0) {
                        return this.intervals[0]['mouse'] ? 'w-1/12' : 'w-0 origin-left'
                    }
                    if(index == 1) {
                        return this.intervals[0]['mouse'] ? 'w-5/6 z-30' : 'origin-center w-full'
                    }
                    if(index == 2) {
                        return this.intervals[0]['mouse'] ? 'w-1/12' : 'origin-right w-0';
                    }

            }
        },
        getKey(e) {
            // console.log(e);
        }
   }
}
</script>

<style lang="postcss">
    div.panel, div.panel figure{
        @apply h-screen;
        background-repeat:no-repeat;
        background-size:cover;
        background-position:center;
        transition: all 1s cubic-bezier(0.075, 0.82, 0.165, 1);
    }

    .list-enter-active,
.list-leave-active {
  transition: all 0.5s ease;
}
.list-enter-from,
.list-leave-to {
    opacity: 0;
    transform: scaleX(0);
    /**  transform: translateX(30px); **/
}

</style>
